import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../context/AuthContext';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import axios from "axios";
//import { Home } from '@mui/icons-material';

const Dashboard = () => {
  //const { logout, role } = useContext(AuthContext);
  const navigate = useNavigate();
  const [aplikace, setAplikace] = useState([]);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => {
    const fetchData = async () => {
      /*try {
        const response = await fetch("https://api.example.com/data");
        const result = await response.json();
        setData(result); // Uložení dat do stavu
      } catch (error) {
        console.error("Chyba při načítání dat:", error);
      }*/
      const data0 = await axios.get("/api/apps", { headers: getAuthHeaders(), params:{}});
      setAplikace(data0.data);

    };

    fetchData();

    document.title = 'Dashboard';
    
  }, []);
  
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

  return (
    
    <Container>
      
      <MenuAppBar title='Dashboard' />
      
      <Box sx={{ flexGrow: 1 }} mt={1}>
      <Grid container spacing={2}>
        
        {aplikace.map((data, index) => (
          <Grid size={2} key={'appsg-'+index}>
            <Item>
              <Card variant="outlined" style={{cursor: 'pointer'}} onClick={() => navigate("/"+data.appsName)}>
              <CardContent>
                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                  Aplikace
                </Typography>
                <Typography variant="h5" component="div">
                  {data.appsName}
                </Typography>
              </CardContent>
              </Card>
            </Item>
          </Grid>
        ))}
          
        
      </Grid>
      </Box>
      <MenuBottAppBar value={'Dashboard'} />
    </Container>
       
  );
};

export default Dashboard;
